import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import getters from './getters'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    user
  },
  getters,
  state: {
    _axiosPromiseCancel: [],  //axios cancelToken队列
  },
  mutations: {
    SET_AXIOSPROMISECANCEL: (state, c) => {
      if (typeof c === 'function') {
        state._axiosPromiseCancel.push(c);
      } else if (typeof c === 'object') {
        state._axiosPromiseCancel = c;
      }
    }
  }
})

export default store


// WEBPACK FOOTER //
// ./src/store/index.js